<template>
    <div class="col-xl-12 float-left background-fff mb-3 roi-widget padding15">
        <div class="row mb-3 align-items-center">
            <div class="col-6">
                <h6 class="proxima-nova-bold">Invoices</h6>
            </div>
            <div class="col-6">
                <invoice-modal
                    :client-id="order.client.id"
                    :order-id="order.id"
                    @invoice-added="onInvoiceAdded"
                    class="float-right"
                />
            </div>
        </div>
        <invoices
            v-if="invoices.length > 0"
            :invoices="invoices"
            :show-client="false"
            :show-order="false"
            :id="id"
        />
        <div v-else class="text-black-50 text-center">
            <p class="h5 p-2">There are no invoices.</p>
        </div>
    </div>
</template>

<script>
    export default {
        components: { },
        props: ['order','id'],
        data() {
            return {
                invoices: [],
            };
        },
        mounted() {
            this.fetchInvoices();
        },
        methods: {
            fetchInvoices() {
                axios.get('/order/invoices', { params: { order_id: this.order.id } }).then((res) => {
                    //TODO! a hack
                    res.data.forEach(invoice => {
                        invoice.loading = false;
                    });
                    this.invoices = res.data;
                }).catch(e => {
                    console.log(e);
                });
            },
            onInvoiceAdded(){
                this.fetchInvoices();
            },
        },
    }
</script>
